import { getImageByKey } from "../data/imageMap";

const traits = [
  { title: "Embedded Systems", subtitle: "Bare metal, RTOS, FPGAs", imageKey: "cardEmbedded", suit: "♦" },
  { title: "Cryptographer", subtitle: "ZK proofs, protocol design", imageKey: "cardCrypto", suit: "♠" },
  { title: "Roboticist", subtitle: "Perception, control, ROS2", imageKey: "cardRobotics", suit: "♣" },
  { title: "Blockchain Dev", subtitle: "Provers, verifiers, chains", imageKey: "cardBlockchain", suit: "♥" },
];

const redSuits = new Set(["♦", "♥"]);

const handlePointerMove = (e) => {
  const card = e.currentTarget;
  const rect = card.getBoundingClientRect();
  const px = (e.clientX - rect.left) / rect.width;
  const py = (e.clientY - rect.top) / rect.height;
  card.style.setProperty("--rx", `${(0.5 - py) * 14}deg`);
  card.style.setProperty("--ry", `${(px - 0.5) * 14}deg`);
  card.style.setProperty("--mx", `${px * 100}%`);
  card.style.setProperty("--my", `${py * 100}%`);
  card.style.setProperty("--shine-opacity", "1");
};

const handlePointerLeave = (e) => {
  const card = e.currentTarget;
  card.style.setProperty("--rx", "0deg");
  card.style.setProperty("--ry", "0deg");
  card.style.setProperty("--shine-opacity", "0");
};

export const TraitCards = () => {
  return (
    <div className="trait-cards">
      {traits.map((trait, index) => (
        <div className="trait-card" key={trait.title} style={{ "--card-index": index }}>
          <div
            className="trait-card-tilt"
            onPointerMove={handlePointerMove}
            onPointerLeave={handlePointerLeave}
          >
            {/* above the fold — eager so these don't delay LCP */}
            <img
              src={getImageByKey(trait.imageKey)}
              alt=""
              decoding="async"
              fetchpriority="high"
            />
            <div className="trait-card-rank" aria-hidden="true">
              <span className="trait-card-rank-letter">A</span>
              <span className={`trait-card-suit ${redSuits.has(trait.suit) ? "suit-red" : "suit-black"}`}>
                {trait.suit}
              </span>
            </div>
            <div className="trait-card-overlay">
              <h3>{trait.title}</h3>
              <p>{trait.subtitle}</p>
            </div>
            <div className="trait-card-shine" aria-hidden="true" />
            <div className="trait-card-holo" aria-hidden="true" />
          </div>
        </div>
      ))}
    </div>
  );
};
